module.exports = __webpack_public_path__ + "img/hood neckline length.10774f50.png";